<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      form: {
        id_bank: null,
        nama_bank: "",
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        // 👉 modal OPENED
        if (this.mode === "edit" && this.data) {
          this.form = { ...this.data };
        } else {
          this.resetForm();
        }
      } else {
        // 👉 modal CLOSED
        this.resetForm();
      }
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {
    resetForm() {
      this.form = {
        id_bank: null,
        nama_bank: "",
      };
    },

    store() {
      if (!this.form.nama_bank) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Nama bank tidak boleh kosong.",
          showConfirmButton: true,
        });

        return;
      }

      const url =
        this.mode === "edit"
          ? this.BACKEND_URL_VERSION +
            "master-verifikasi/master-bank/" +
            this.form.id_bank
          : this.BACKEND_URL_VERSION + "master-verifikasi/master-bank";

      const method = this.mode === "edit" ? "put" : "post";

      axios({
        method,
        url,
        data: { nama_bank: this.form.nama_bank },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          // reload table
          this.$emit("finish");
        })
        .catch((err) => {
          const respData = err.response?.data?.data;
          let message = "Terjadi kesalahan.";

          if (Array.isArray(respData?.error)) {
            message = respData.error.join("<br>");
          } else if (typeof respData === "string") {
            message = respData;
          } else if (err.response?.data?.meta?.message) {
            message = err.response.data.meta.message;
          }

          Swal.fire({
            icon: "error",
            title: "Gagal",
            html: message,
          });
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Tambah / Edit Master Bank"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">
      <b-form-group label="Nama Bank" class="fw-medium">
        <b-form-input v-model="form.nama_bank"></b-form-input>
      </b-form-group>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary"> Simpan </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
